import React from 'react';
import * as styles from './styles.module.scss';

export function FooterMobile({ className }) {
  return (
    <div className={[className]}>
    </div>
  )
}